import comboCustomOptionsModalTemplate from '../templates/comboCustomOptionsModal.html';
function comboCustomOptionsModalDirective() {
  return {
    restrict: 'E',
    controller: comboCustomOptionsModalCtrl,
    controllerAs: 'comboCustomOptionsModal',
    bindToController: true,
    scope: {
      productId: '<',
      offerId: '<',
      priceAdded: '<',
      onInitFn: '&',
      onBeforeChangeFn: '&',
      onChangeFn: '&',
      close: '&',
      onClosePositionsModal: '&',
      currencySymbol: '<',
      customOptionComboView: '<?',
      customOptionPicture: '<?'
    },
    templateUrl: comboCustomOptionsModalTemplate
  };
}

/* @ngInject */
function comboCustomOptionsModalCtrl(comboStateService) {
  var ctrl = this;
  ctrl.$onInit = function () {
    ctrl.comboItemCtrl = comboStateService.getActiveItem();
  };
}
comboCustomOptionsModalCtrl.$inject = ["comboStateService"];
export { comboCustomOptionsModalDirective };